import { createContext, Dispatch, SetStateAction, useContext, useEffect } from 'react'

const DashboardTitleContext = createContext<{
  setTitle: Dispatch<SetStateAction<string>>
}>({
  setTitle: () => {
    /* Default no-op */
  },
})

export const DashboardTitle = ({ title }) => {
  const context = useContext(DashboardTitleContext)

  useEffect(() => {
    context.setTitle(title)
  }, [context, title])

  return null
}

export const DashboardTitleProvider = DashboardTitleContext.Provider
